export const SECTION = {
  about: {
    id: 'about',
    headerTitle: 'About Me',
    sectionTitle: 'A Quick Look At The Human Here',
  },
  skills: {
    id: 'skills',
    headerTitle: 'My Skills',
    sectionTitle: 'Tools That Make Me Look Competent',
  },
  projects: {
    id: 'projects',
    headerTitle: 'My Projects',
    sectionTitle: 'My Favorite Digital Frankensteins',
  },
  awards: {
    id: 'awards',
    headerTitle: 'My Awards',
    sectionTitle: 'Shiny Things I Somehow Earned',
  },
  contact: {
    id: 'contact',
    headerTitle: 'Contact Me',
    sectionTitle: 'Your Portal To Summon My Attention',
  },
};
